import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './Login.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Retrieve existing users from localStorage
    const users = JSON.parse(localStorage.getItem('users')) || [];

    // Find the user with the entered username
    const user = users.find(user => user.username.toLowerCase() === username.toLowerCase());

    if (!user) {
      alert("Account does not exist");
      setUsername('');
      setPassword('');
      return;
    } else {
      if (user.password === password) {
        alert('Login successful');
        onLogin(username);
        navigate("/");
      } else {
        alert('Invalid password');
        setPassword('');
        return;
      }
    }
  };

  return (
    <div className="loginDiv">
      <form className="loginForm" onSubmit={handleSubmit}>
        <h2>Login To Account</h2>
        <br/>
        <div>
          <input
            placeholder="Username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <input
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;